import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Wishlist item interface
interface WishlistItem {
  id: string;
  title?: string;
  imgSrc?: string;
  price: number;
  rating?: number;
  reviews?: number;
  quantity: number;
  categories?: string;
}

// Wishlist state containing only items
interface WishlistState {
  items: WishlistItem[];
}

const LOCAL_STORAGE_KEY = "wishlistState";
const defaultWishlistItem: WishlistItem[] = [{
  id: '5',
  title: 'Fresh Pumpkin',
  imgSrc: '/images/product/popular/10.png',
  price: 31.0,
  rating: 4.7,
  reviews: 87,
  quantity: 1,
  categories: 'Features',
},
{
  id: "1",
  title: 'Bloom Delight',
  imgSrc: '/images/product/popular/6.png',
  rating: 4.5,
  reviews: 26,
  price: 16.0,
  categories: 'Best sellers',
  quantity: 1,
},
{
  id: '2',
  title: 'Vibrant Pepper',
  imgSrc: '/images/product/popular/7.png',
  rating: 4.9,
  reviews: 25,
  price: 6.0,
  categories: 'Best sellers',
  quantity: 1,
},
];

// Load wishlist from local storage
const loadWishlistFromLocalStorage = (): WishlistState => {
  if (typeof window !== "undefined") {
    try {
      const storedWishlist = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (storedWishlist && storedWishlist !== "undefined") {
        const parsedWishlist = JSON.parse(storedWishlist);
        if (Array.isArray(parsedWishlist) && parsedWishlist.length > 0) {
          return { items: parsedWishlist };
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Return the default item if no valid localStorage found
  return { items: [...defaultWishlistItem] };
};


const initialState: WishlistState = loadWishlistFromLocalStorage();

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    toggleWishlistItem: (state, action: PayloadAction<WishlistItem>) => {
      const existingIndex = state.items.findIndex((item) => item.id === action.payload.id);
      
      if (existingIndex !== -1) {
        // If item exists, remove it
        state.items.splice(existingIndex, 1);
      } else {
        // If item doesn't exist, add it
        state.items.push(action.payload);
      }

      // Update localStorage
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },

    clearWishlist: (state) => {
      state.items = [];
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },
  },
});

export const { toggleWishlistItem, clearWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
